import React from 'react';
import { useStyletron } from 'baseui';
import _map from 'lodash/map';

import RowRenderer from '../renderer/RowRenderer';

interface IFormProps {
	fieldConfig: any;
	layoutConfig: any;
	mode: any;
	control: any;
	errors: any;
	watch: any;
	setValue: any;
	setShowLoader: any;
	initialValues: any;
}

const Form: React.FC<IFormProps> = (props) => {
	const { fieldConfig, layoutConfig, mode, control, errors, watch, setValue, setShowLoader, initialValues } = props;
	const [css] = useStyletron();

	return (
		<div className={css({ display: 'flex', flexDirection: 'column', gap: '10px' })}>
			{_map(layoutConfig, (layout, index) => {
				return (
					<RowRenderer
						key={layout.getKey() || index}
						fieldConfig={fieldConfig}
						layoutProps={layout}
						control={control}
						errors={errors}
						setShowLoader={setShowLoader}
						mode={mode}
						watch={watch}
						setValue={setValue}
						initialValues={initialValues}
					/>
				);
			})}
		</div>
	);
};

export default Form;
